{
  const initFeaturedStories = () => {
    const storyCopies = document.querySelectorAll('.featured-story');
    let activeStory = document.querySelector(`.featured-story__card--active`);
    let activeStoryHandle = activeStory ? activeStory.getAttribute('data-story-handle') : null;
    let currentTimeout = null;
    let currentIndex = 1; // Start from 1 since the first card is already active
    let bufferTimeout = null;

    if (storyCopies.length > 0) {
      storyCopies.forEach((story) => {
        // Add mouseleave event to clear buffer timeout
        story.addEventListener('mouseleave', () => {
          if (bufferTimeout) {
            clearTimeout(bufferTimeout);
            bufferTimeout = null;
          }
        });

        story.addEventListener('mouseenter', () => {
          const storyHandle = story.getAttribute('data-story-handle');
          
          // Skip if already on this story
          if (storyHandle === activeStoryHandle) return;
          
          // Clear any existing buffer timeout from previous hovers
          if (bufferTimeout) clearTimeout(bufferTimeout);
          
          // Create a buffer timeout - only trigger animation after 300ms
          bufferTimeout = setTimeout(() => {
            // Clear any pending animation timeout
            if (currentTimeout) clearTimeout(currentTimeout);
            
            // Remove leaving class from any cards
            document.querySelectorAll('.featured-story__card--leave').forEach(card => {
              card.classList.remove('featured-story__card--leave');
            });
            
            // Update active elements
            const storyWrapper = story.querySelector('.featured-story__content-wrapper');
            const storyCard = document.querySelector(`.featured-story__card[data-story-handle="${storyHandle}"]`);
            
            // Remove active classes from previous elements
            document.querySelectorAll('.featured-story__active').forEach(el => {
              el.classList.remove('featured-story__active');
            });
            
            document.querySelectorAll('.featured-story__card--active').forEach(card => {
              card.classList.add('featured-story__card--leave');
              card.classList.remove('featured-story__card--active');
            });
            
            // Set new active elements
            storyWrapper.classList.add('featured-story__active');
            storyCard.classList.add('featured-story__card--active');
            // storyCard.style.zIndex = currentIndex++;
            activeStoryHandle = storyHandle;
            
            // Clean up leaving cards after animation
            currentTimeout = setTimeout(() => {
              document.querySelectorAll('.featured-story__card--leave').forEach(card => {
                card.classList.remove('featured-story__card--leave');
              });
            }, 400); // Reduced to 300ms to match your total animation time
            
            bufferTimeout = null;
          }, 400);
        });
      });
    }
  };

  document.addEventListener('DOMContentLoaded', initFeaturedStories);
}